<!--
  @Description 批量说明新增
  @Date 2021-12-31
  @Author liushuo
-->
<template>
  <div class="modal-dv">
    <vxe-modal
      v-model="isShow"
      title="批量新增说明"
      size="mini"
      width="40%"
      height="auto"
      @show="showWindows"
      @close="closeWindows"
    >
      <div class="edit-dv">
        <el-form :model="form" ref="FormRef" :validate-on-rule-change="false" :rules="rules" size="small">
          <!-- 第一行 -->
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="说明类型" prop="type">
                <el-select clearable v-model="form.type" :placeholder="placeholderConfig.select">
                  <el-option
                    :index="item + ''"
                    v-for="item in combobox.type"
                    :key="item.name"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第二行 -->
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="说明内容" prop="comment">
                <el-input
                  type="textarea"
                  :rows="4"
                  v-model="form.comment"
                  autocomplete="off"
                  :placeholder="placeholderConfig.input"
                  resize="none"
                ></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="btn-dv">
        <button @click="save">保存</button>
      </div>
    </vxe-modal>
  </div>
</template>

<script>
export default {
  name: 'moreInstructionEdit',
  props: {
    parentObj: Object
    // 拉选的行id
    // idList: {
    //   type: Array,
    //   default: () => {
    //     return []
    //   }
    // },
  },
  data() {
    return {
      // 弹窗是否打开
      isShow: false,
      form: {
        comment: '',
        type: ''
      },
      rules: {
        type: [{ required: true, message: '请选择说明类型', trigger: 'change' }]
      },
      // 下拉框列表
      combobox: {
        // 说明类型
        type: []
      },
      curPost: [],
      // 人员对应的字典
      personMap: {
        提出人: 'createtor',
        前端研发: 'frontEngineer',
        后端研发: 'backEngineer',
        技术测试: 'techTester',
        业务测试: 'businessTester'
      },
      idList: [],
      numList: []
    }
  },
  methods: {
    showWindows() {
      // this.setFormRules()
      // 赋值历史说明
      // this.setHistoryInsList()
      this.setSelectOptions()
      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
      })
    },
    // 根据岗位过滤下拉选项
    setSelectOptions() {
      const _ = this
      // 默认可以写说明，如：本问题为非本人数据时，仅可写说明
      let commentType = [
        {
          name: '说明',
          value: '说明'
        }
      ]
      // 1.有超级权限的全部可见
      if (this.$parent.specialAuthority.super) {
        commentType.push(
          // {
          //   name: '说明',
          //   value: '说明'
          // },
          {
            name: '解决',
            value: '解决'
          },
          {
            name: '不处理',
            value: '不处理'
          },
          {
            name: '通过',
            value: '通过'
          },
          {
            name: '驳回',
            value: '驳回'
          },
          {
            name: '关闭',
            value: '关闭'
          },
          {
            name: '激活',
            value: '激活'
          }
        )
        this.combobox.type = this.filterRepeat(commentType, 'name')
        return
      }
      // 2.研发（解决）
      if (_.curPost_List.includes(_.personMap['前端研发']) || _.curPost_List.includes(_.personMap['后端研发'])) {
        commentType.push(
          // {
          //   name: '说明',
          //   value: '说明'
          // },
          {
            name: '解决',
            value: '解决'
          },
          {
            name: '不处理',
            value: '不处理'
          }
        )
      }
      // 3.测试（通过、驳回）
      if (_.curPost_List.includes(_.personMap['技术测试']) || _.curPost_List.includes(_.personMap['业务测试'])) {
        commentType.push(
          // {
          //   name: '说明',
          //   value: '说明'
          // },
          {
            name: '通过',
            value: '通过'
          },
          {
            name: '驳回',
            value: '驳回'
          },
          {
            name: '不处理',
            value: '不处理'
          }
        )
      }
      // 4.项目经理，即提出人（关闭、激活）
      if (_.curPost_List.includes(_.personMap['提出人'])) {
        commentType.push(
          // {
          //   name: '说明',
          //   value: '说明'
          // },
          {
            name: '驳回',
            value: '驳回'
          },
          {
            name: '关闭',
            value: '关闭'
          },
          {
            name: '激活',
            value: '激活'
          }
        )
      }
      this.combobox.type = this.filterRepeat(commentType, 'name')
    },
    // 去重
    filterRepeat(array, prop) {
      let map = new Map()
      array.forEach(item => {
        if (!map.has(item[prop])) {
          map.set(item[prop], item)
        }
        return map.values()
      })
      return [...map.values()]
    },
    // 监听模态框关闭
    closeWindows() {
      // this.$refs['FormRef'].resetFields()
    },
    async save() {
      const valid = await this.validEnter()
      if (!valid) {
        return
      }
      const { data: res } = await this.$http.post('/Common/YKCase/addcomment', {
        iDs: this.idList,
        numList: this.numList,
        type: this.form.type,
        memo: this.form.comment
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      this.$message.success(res.data)

      // 在保存后清空当前表单输入数据
      this.form = {
        comment: '',
        type: ''
      }
      // 关闭弹窗
      this.isShow = false
      // 重新刷新主页面（局部刷新）
      this.parentObj.getListPart(this.idList)
      // this.$parent.getList(false, false)
    },
    // 验证
    async validEnter() {
      let flag = true
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      if (!flag) {
        this.$message.error('验证失败,请核对输入数据')
      }
      return flag
    }
  },
  computed: {
    // 当前岗位数组
    curPost_List() {
      return this.curPost[0].split(',')
    }
  }
}
</script>

<style lang="less" scoped>
@btn-dv-height: 60px;
.modal-dv {
  position: relative;
}

.edit-dv {
  width: 100%;
  height: calc(100% - @btn-dv-height);
  box-sizing: border-box;
  padding: 0 15px;
  margin: 0 auto;
}

.btn-dv {
  width: 100%;
  height: @btn-dv-height;
  .fl;

  > button {
    width: 130px;
    height: 40px;
    background-color: @primary-color;
    color: @text-color;
    outline: none;
    border: none;
    border-radius: 10px;
    transition: @normal-transition;
    font-size: 16px;
  }

  > button:hover {
    cursor: pointer;
    opacity: 0.7;
  }

  > button:active {
    opacity: 0.9;
  }
}
</style>
